import { isNil } from 'lodash';

type Assert = <T extends unknown>(value: T, errorMessage?: string) => asserts value is NonNullable<T>;

export type OptionalFields<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export const assertNotNil: Assert = (value, errorMessage) => {
    if (isNil(value)) {
        throw new Error(errorMessage ?? `Expected non-nil value, but got ${value} instead`);
    }
};
